import Moment from "moment";

const MomentDateFormat = function (date: any) {
  return Moment(date).isValid() ? Moment(date) : Moment(date, "YYYY-MM-DD");
};
export { MomentDateFormat };

const getDateStatusColor = function (date: any) {
  let ReformatedDate = MomentDateFormat(date);
  return parseInt(Moment(ReformatedDate).format("YYYYMMDD").toString()) <
    parseInt(Moment(new Date()).format("YYYYMMDD").toString())
    ? "#C0C0C0"
    : "#82a9cf"; // C0C0C0 gray - 82a9cf blue
};
export { getDateStatusColor };

const getStatusIcon = function (status: string) {
  if (status === "Open") {
    return "gold";
  } else if (status === "Complete") {
    return "#2ECC71"; //green
  } else {
    return "red"; //red
  }
};
export { getStatusIcon };

const getStatusIconByDueDate = function (dueDate: any) {
  let itemDate = Moment(dueDate, "YYYY-MM-DD").toDate();
  if (itemDate < new Date()) {
    return "red"; //red
  } else {
    return "gold";
  }
};
export { getStatusIconByDueDate };

export const TimelineItemDateText = function (dateSTR: any) {
  return MomentDateFormat(dateSTR).format("YYYYMMDD").toString() ==
    Moment(new Date()).format("YYYYMMDD").toString()
    ? "Today"
    : MomentDateFormat(dateSTR).format("DD/MM/YYYY").toString();
};

export const MatterItemDateText = function (dateSTR: any) {
  return MomentDateFormat(dateSTR).format("DD/MM/YYYY").toString();
};

export const CheckIfNotActive = function (status: any) {
  return status !== "Complete";
};

export const IsOpenDescript = function (date: any) {
  return MomentDateFormat(date).format("YYYYMMDD").toString() ===
    MomentDateFormat(new Date()).format("YYYYMMDD").toString()
    ? true
    : false;
};
